// extracted by mini-css-extract-plugin
module.exports = {"faqSection":"FaqSectionComponent_faqSection__ekdMO","gwSectionContainer":"FaqSectionComponent_gwSectionContainer__8y0rP"};